import { normalizeQuantityUnit } from '../components/quantityUnit';
import type { ResourceType } from '../platform/pipeline-kernel/types';
import { toVendorDeviceSubmitFields } from './vendorDeviceSubmit';

function requirementOrDefault(value: unknown, fallback = '1'): string {
  if (value === undefined || value === null || value === '') return fallback;
  return String(value);
}

/** 计价选型元数据输入（含 quantityUnit / deviceType） */
export type PricingResourceMetaInput = {
  vendorID?: string;
  deviceID?: string;
  vendor?: string;
  device?: string;
  deviceType?: string;
  requirement?: string;
  quantityUnit?: string;
} | null;

/**
 * 从计价选型元数据组装 resourceConfigs 覆盖字段。
 * 有 quantityUnit 时覆盖模板 unit；直建无选型时不写 unit，保留模板默认。
 * 所有交付类型投影应优先使用本函数，禁止手写 unit 覆盖。
 */
export function pickPricingResourceMeta(
  primary: PricingResourceMetaInput | undefined,
  fallbackRequirement: string,
): Pick<ResourceType, 'vendorID' | 'deviceID' | 'vendor' | 'device' | 'deviceType' | 'requirement' | 'unit'> {
  const quantityUnit = normalizeQuantityUnit(primary?.quantityUnit);
  const deviceType = primary?.deviceType != null ? String(primary.deviceType).trim() : '';
  return {
    ...toVendorDeviceSubmitFields(primary),
    ...(deviceType ? { deviceType } : {}),
    requirement: requirementOrDefault(primary?.requirement, fallbackRequirement),
    ...(quantityUnit ? { unit: quantityUnit } : {}),
  };
}

/**
 * 模板 + 选型 → 完整 ResourceType。
 * 等价于 `{ ...template, ...pickPricingResourceMeta(meta, requirement), requirement }`。
 */
export function buildResourceConfigFromPricing(
  template: ResourceType,
  meta: PricingResourceMetaInput | undefined,
  requirement: string,
): ResourceType {
  return {
    code: template.code,
    description: template.description,
    unit: template.unit,
    ...pickPricingResourceMeta(meta, requirement),
    requirement,
  };
}
